<template>
  <el-dialog
    :visible="isDialogVisible"
    :title="currentFoodItem?.name || $t('OrderFood.Spec')"
  >
    <div v-for="(spec, specIndex) in filteredSpecGroups" :key="specIndex" class="spec-group">
      <div class="spec-group__title">
        {{ spec.name }}
      </div>
      <div class="spec-group__content">
        <template v-if="spec.children.length > 0">
          <div v-for="(opt, optIndex) in spec.children" :key="optIndex" class="spec-group__option">
            <el-checkbox v-if="mode === 'design'" v-model="opt.isOption" size="medium" :true-label="1" :false-label="0">
              {{ opt.name }}
            </el-checkbox>
            <el-checkbox v-else v-model="opt.isChecked" size="medium" @change="(val) => handleCheckboxChange(spec, optIndex, val)">
              {{ opt.name }}
            </el-checkbox>
          </div>
        </template>
        <template v-else>
          <div class="spec-group__option--none">
            ({{ $t('OrderFood.NoCreatedSpecOptions') }})
          </div>
        </template>
      </div>
    </div>
    <div slot="footer">
      <el-button round @click="isDialogVisible = false">
        {{ $t('General.Cancel') }}
      </el-button>
      <el-button round type="primary" @click="handleClickConfirm">
        {{ $t('General.Confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SelectSpecDialog',
  props: {
    // 模式
    mode: {
      type: String,
      default: 'design' // design: 規格編輯頁面使用 order: 點餐頁面使用
    },
    // 目標品項索引
    targetIndex: {
      type: Number,
      required: true
    },
    targetId: {
      type: String
    },
    // 目標品項已經選擇的規格
    selectedSpec: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isDialogVisible: false, // 是否顯示對話框
      specGroups: [], // 規格群組
      currentFoodItem: null // 餐點品項
    }
  },
  computed: {
    // 過濾掉內容為空的規格項目
    filteredSpecGroups () {
      return this.specGroups.filter(spec => spec.children.length > 0)
    }
  },
  methods: {
    open () {
      this.isDialogVisible = true
      this.initSpecGroups()
      this.fillSelectedSpec()
    },
    /**
     * 初始化規格群組
     * 1. 有菜單ID時，從菜單獲取規格
     * 2. 沒有菜單ID時，從規格列表獲取規格
     */
    initSpecGroups () {
      this.specGroups.length = 0
      this.$nextTick(() => {
        if (this.mode === 'design') {
          this.specGroups = _cloneDeep(this.$store.getters.getAvailableSpecList)
          this.specGroups.forEach(spec => spec.children.forEach(opt => {
            this.$set(opt, 'isOption', 0)
          }))
        } else {
          this.currentFoodItem = this.$store.getters.getMenuFoodItem(this.targetId)
          const specList = _cloneDeep(this.currentFoodItem.chooses)
          specList.forEach(spec => {
            this.specGroups.push({
              ...spec,
              children: spec.children.filter(opt => opt.isOption === 1).map(opt => {
                return {
                  ...opt,
                  isChecked: false
                }
              })
            })
          })
        }
      })
    },
    /**
     * 填充已選擇的規格
     */
    fillSelectedSpec () {
      this.$nextTick(() => {
        this.specGroups.forEach(sg => {
          sg.children.forEach(sgOpt => {
            if (this.mode === 'design') {
              /**
               * 1. 把 selectedSpec(chooses) 的 children 陣列攤平然後篩選出設定為選項(isOption=1)的所有規格
               * 2. 透過 id 比對是否有選中的規格，並且將 specGroups 中對應的規格設定為勾選(isOption=1)
               */
              sgOpt.isOption = this.selectedSpec.flatMap(ss => ss.children).filter(sso => sso.isOption === 1).some(sso => sso.id === sgOpt.id) ? 1 : 0
            } else {
              sgOpt.isChecked = this.selectedSpec.flatMap(ss => ss.children).filter(sso => sso.isChecked).some(sso => sso.id === sgOpt.id)
            }
          })
        })
      })
    },
    /**
     * 處理勾選框異動
     */
    handleCheckboxChange (spec, optIndex, val) {
      // 如果是要勾選
      if (val) {
        // 除了當前選項外，其他選項都要取消勾選
        spec.children.forEach((opt, i) => {
          if (i !== optIndex) {
            opt.isChecked = false
          }
        })
      }
    },
    /**
     * 處理點擊確認
     */
    handleClickConfirm () {
      this.isDialogVisible = false
      this.$emit('confirm', { index: this.targetIndex, selectedSpec: _cloneDeep(this.specGroups) })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  // @include basicDialog();
  width: 550px;
  border-radius: 16px;
  &__header {
    position: relative;
    display: flex;
    justify-content: flex-start;
  }
  &__header::after {
    content: '';
    position: absolute;
    top: 100%;
    width: 90%;
    border-bottom: 1px solid $lightFontColor;
  }
  &__headerbtn {
    display: none;
  }
  &__body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 200px;
    overflow-y: scroll;
  }
  .spec-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
    &__title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    &__content {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
    &__option {
      display: flex;
      align-items: center;
      &--none {
        color: $lightFontColor;
      }
    }
  }
  &__footer {
    display: flex;
    justify-content: center;
    gap: 20px;
  }
}
</style>
